import React from "react";
import { FaMicrochip, FaSwatchbook, FaProjectDiagram } from "react-icons/fa";

function WhyChooseXeer() {
  const reasons = [
    {
      title: "Blockchain Expertise",
      desc: "Our engineers specialize in crafting premium architectures, guaranteeing highly scalable decentralized operations natively supported globally.",
      icon: "microchip",
      color: "#3f51b5",
    },
    {
      title: "User-Centric Design",
      desc: "We prioritize providing intuitively fluid smart interfaces accommodating novices while preserving complex yield portfolios efficiently.",
      icon: "swatchbook",
      color: "#00bcd4",
    },
    {
      title: "End-to-End Solutions",
      desc: "From strategizing through intensive audits, our execution comprehensively handles all deployment domains finalizing unparalleled operational capabilities.",
      icon: "project",
      color: "#673ab7",
    },
  ];

  // 🔥 icon mapping
  const iconMap = {
    microchip: FaMicrochip,
    swatchbook: FaSwatchbook,
    project: FaProjectDiagram,
  };

  return (
    <div
      className="services-area pt-120 pb-120"
      style={{ background: "#ffffff" }}
    >
      <div className="container">
        <div className="row text-center mb-5 mt-4">
          <div className="col-lg-8 offset-lg-2">
            <h2
              className="title fw-extrabold mb-4"
              style={{ fontWeight: "bold" }}
            >
              Why Choose Xeer Technology for Your DeFi Staking Platform?
            </h2>
            <p className="text-muted fs-5">
              At Xeer Technology, our proven credibility effectively translates
              complex distributed ideologies into superior enterprise platforms.
            </p>
          </div>
        </div>

        <div className="row g-4 justify-content-center">
          {reasons.map((reason, index) => {
            const Icon = iconMap[reason.icon]; // 🔥 dynamic icon

            return (
              <div className="col-lg-4 col-md-6" key={index}>
                <div
                  className="reason-card border-0 p-5 text-center h-100"
                  style={{
                    borderRadius: "40px",
                    background: "#ffffff",
                    boxShadow: "0 20px 50px rgba(0, 0, 0, 0.05)",
                    transition: "all 0.3s ease",
                    border: "1px solid #f8f9fa",
                    cursor: "default",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-10px)";
                    e.currentTarget.style.boxShadow =
                      "0 30px 70px rgba(63, 81, 181, 0.12)";
                    e.currentTarget.style.borderColor = "#3f51b515";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 20px 50px rgba(0, 0, 0, 0.05)";
                    e.currentTarget.style.borderColor = "#f8f9fa";
                  }}
                >
                  <div
                    className="icon-box mx-auto d-flex align-items-center justify-content-center mb-4"
                    style={{
                      width: "90px",
                      height: "90px",
                      background: `linear-gradient(45deg, ${reason.color}15, ${reason.color}05)`,
                      color: reason.color,
                      borderRadius: "50%",
                      border: `1px solid ${reason.color}10`,
                    }}
                  >
                    <Icon size={36} />
                  </div>

                  <h4
                    className="fw-extrabold mb-3"
                    style={{ fontSize: "22px", fontWeight: "bold" }}
                  >
                    {reason.title}
                  </h4>
                  <p
                    className="text-muted mb-0 fs-6"
                    style={{ lineHeight: "1.8" }}
                  >
                    {reason.desc}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default WhyChooseXeer;
